// Home.js
import React, { useState, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';


import { API_BASE_URL, handleFile, renderModal, closeModal, fetchJsonFromUrl, Breadcrumbs } from './Common';

import { ReactComponent as UploadIcon } from '../icons/upload.svg';
import { ReactComponent as MugIcon } from '../icons/mug.svg';
import { ReactComponent as FilecheckIcon } from '../icons/filecheck.svg';

import './Home.css';

const normalizeSheets = (sheets) => {
  return sheets.map(sheet => {
    const hasNoHeaders =
      !Array.isArray(sheet.data) ||
      sheet.data.length === 0 ||
      !Array.isArray(sheet.data[0]) ||
      sheet.data[0].length === 0;

    if (hasNoHeaders) {
      return {
        ...sheet,
        data: [
          ["Coluna 1", "Coluna 2", "Coluna 3"],
          ["", "", ""]
        ]
      };
    }

    return sheet;
  });
};


function CreateProject() {
  const navigate = useNavigate();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [filesSelected, setFilesSelected] = useState(false);
  const [healthData, setHealthData] = useState([]);
  const [projectName, setProjectName] = useState('');
  const [url, setURL] = useState('');
  const [isCreating, setIsCreating] = useState(false); // State variable to track duplication process
  const [selectedOption, setSelectedOption] = useState(null); // State variable to track selected option

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalMessageColor, setModalMessageColor] = useState('');
  const [modalIconId, setModalIconId] = useState(1);

  const [saveAsStatic, setSaveAsStatic] = useState(true);
  const MAX_TOTAL_FILE_SIZE = 20 * 1024 * 1024; // 10 MB

  const onDrop = useCallback((acceptedFiles) => {
  if (acceptedFiles.length > 0) {

    // Calculate current uploaded size
    const currentSize = uploadedFiles.reduce((sum, file) => sum + file.size, 0);

    // Calculate new files size
    const newFilesSize = acceptedFiles.reduce((sum, file) => sum + file.size, 0);

    const totalSize = currentSize + newFilesSize;

    if (totalSize > MAX_TOTAL_FILE_SIZE) {
      setModalMessage(`O tamanho dos ficheiros excede o limite de ${MAX_TOTAL_FILE_SIZE / (1024 * 1024)} MB.`);
      setModalMessageColor('#E5004E');
      setModalIconId(2);
      setIsModalOpen(true);

      setUploadedFiles([]);
      setHealthData([]);
      setFilesSelected(false);
      return; // ❌ Stop upload
    }

    let allFilesData = [];

    acceptedFiles.forEach((file) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const result = event.target.result;

        handleFile(
          file,
          result,
          allFilesData,
          acceptedFiles.length,
          setFilesSelected,
          setHealthData
        );

        setUploadedFiles(prevFiles => [...prevFiles, file]);
      };

      // Get file extension
      const ext = file.name.split('.').pop().toLowerCase();

      // Use correct FileReader method based on file type
      if (ext === 'xml') {
        // ✅ Read as text for XML/JSON (preserves UTF-8 correctly)
        reader.readAsText(file, 'UTF-8');
      } else {
        // XLSX / CSV / ODS → binary
        reader.readAsBinaryString(file);
      }
    });
  }
}, [uploadedFiles]);

  const totalSizeMB = (
  uploadedFiles.reduce((sum, file) => sum + file.size, 0) /
  (1024 * 1024)
).toFixed(2);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ['.xlsx', '.ods', '.csv', '.json', '.xml'],
    multiple: true,
  });

  const handleCreateNewProject = async (projectName) => {
  try {
    setIsCreating(true); // Set the flag to indicate the creation process started
    const token = localStorage.getItem('token');

    let dataToUpload = [];

    // Handle URL option
    if (selectedOption === 'url' && url.trim()) {
      if (saveAsStatic) {
        // Fetch data immediately for static data saving
        const urlData = await fetchJsonFromUrl(url);
        if (urlData) {
          dataToUpload = urlData;
        } else {
  setModalMessage("O URL inserido é inválido.");
  setModalMessageColor('#E5004E');
  setModalIconId(2);
  setIsModalOpen(true);

          setIsCreating(false);
          return;
        }
      } else {
        // Save the URL for real-time data fetching
        dataToUpload = { type: 'real-time', url: url };
      }
    } else if (selectedOption === 'upload' && uploadedFiles.length > 0) {
      dataToUpload = normalizeSheets(healthData);
    } else {
  dataToUpload = [
    {
      sheetName: "Tabela",
      data: [
        ["Coluna 1", "Coluna 2", "Coluna 3"], // Column headers
        ["", "", ""],                      // Row 1 (empty)
        ["", "", ""],                      // Row 2 (empty)
        ["", "", ""]                       // Row 3 (empty)
      ]
    }
  ];
}

    // Make a POST request to the backend with healthData or URL information
    await axios.post(
      `${API_BASE_URL}/create-project`,
      {
        healthData: dataToUpload,
        databaseName: projectName,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Fetch the updated list of projects
    const response = await axios.get(`${API_BASE_URL}/projects`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

      //setProjects(response.data.projects);
      setIsCreating(false);

 setUploadedFiles([]);
 setFilesSelected(false);
 setHealthData([]);
 setProjectName('');
 setURL('');

navigate('/home', {
  state: { projectCreated: true }
});

    } catch (error) {
      console.error('Error creating new project:', error);
      setIsCreating(false);

 setUploadedFiles([]);
 setFilesSelected(false);
 setHealthData([]);
 setProjectName('');
 setURL('');

      // ✅ Check for duplicate project error from backend
    if (error.response?.status === 409) {
      setModalMessage("Já existe um projeto com esse nome!");
    } else {
      setModalMessage("Projeto com erros...");
    }

      setModalMessageColor('#E5004E');
      setModalIconId(2);
      setIsModalOpen(true);
    }
  };

  return (
    <div className="home-container">
    <Breadcrumbs
    items={[
      { label: "Projetos", path: "/home" },
      { label: "Criar Projeto" }
    ]}
  />
      <h2>Criar Projeto</h2>
      <p>Upload de ficheiros para criar projeto</p>

      {/* Loading animation*/}
      {isCreating && (
        <div className="loading-overlay">
        <MugIcon/>
          <div className="loading-message">A carregar os dados...</div>
          <div className="loading-spinner"></div>
        </div>

      )}

      <header>
        <div className="create-project">
          <label className="project-name-label">Nome do Projeto</label>
          <input
            type="text"
            placeholder="Inserir nome do projeto"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
          />

<p className="project-name-label">URL</p>

{(selectedOption === 'upload' || selectedOption === null) && (
          <div className="radio-option">
            <input
              type="radio"
              name="option"
              value="url"
              checked={selectedOption === 'url'}
              onChange={() => setSelectedOption('url')}
            />
          </div>
)}

{selectedOption === 'url' && (
            <>
              <input
                type="text"
                placeholder="Inserir URL"
                value={url}
                onChange={(e) => setURL(e.target.value)}
              />
              {/*
              <div className="url-options">
                <label className="radio-spacing">
                  <input
                    type="radio"
                    name="saveOption"
                    value="static"
                    checked={saveAsStatic}
                    onChange={() => setSaveAsStatic(true)}
                  />
                  Dados Estáticos
                </label>
                <label className="radio-spacing">
                  <input
                    type="radio"
                    name="saveOption"
                    value="real-time"
                    checked={!saveAsStatic}
                    onChange={() => setSaveAsStatic(false)}
                  />
                  Tempo Real
                </label>
              </div>
              */}
            </>
          )}

<div className="project-header">
  <p className="project-name-label">Upload de ficheiros</p>
  <p className="upload-limit">
    {totalSizeMB} MB / {MAX_TOTAL_FILE_SIZE/(1024*1024)} MB
  </p>
</div>

{(selectedOption === 'url' || selectedOption === null) && (
          <div className="radio-option">
            <input
              type="radio"
              name="option"
              value="upload"
              checked={selectedOption === 'upload'}
              onChange={() => setSelectedOption('upload')}
            />
          </div>
)}

{selectedOption === 'upload' && (
            <div className="dropzone-container">
              <div {...getRootProps({ className: 'dropzone' })}>
              {uploadedFiles.length === 0 && (
      <>
              <UploadIcon/>
                <input {...getInputProps()} />
                {
              isDragActive ?
                <p>
                <span className="yellow-text">Solte aqui...</span>
                </p> :
                (<>
                <p>
                <span className="yellow-text">Clique para upload</span>
                <span className="blue-text"> ou arraste e
                <span className="green-text"> solte</span>
                </span>
                </p>
                <p><span className="red-text">(ODS, XLSX, CSV, XML, JSON)</span></p>
                </>
                )
                }
</>
    )}
        {uploadedFiles.length > 0 && (
      <>
      <FilecheckIcon/>
        <p className="file-list-header">Ficheiro inserido!</p>
        <ul>
          {uploadedFiles.map((file, index) => (
            <li key={index} className="file-item">{file.name}</li>
          ))}
        </ul>
      </>
    )}
              </div>
            </div>
          )}


<div className="create-project">
  <button
    className="button"
    style={{
      marginTop: '20px',
      alignSelf: 'flex-end',
      opacity: projectName.trim() === '' ? 0.5 : 1,
      cursor: projectName.trim() === '' ? 'not-allowed' : 'pointer'
    }}
    onClick={() => handleCreateNewProject(projectName)}
    disabled={projectName.trim() === ''} // disable until name is filled
  >
    Criar projeto
  </button>
</div>

        </div>
      </header>

{/*Delete ou Export sucess*/}
{renderModal(isModalOpen, modalMessage, closeModal(setIsModalOpen), modalMessageColor, modalIconId)}

    </div>
  );
}


export default CreateProject;
